// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"livestream-event-LegalNote__wrapper--1L8fw"};